<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="true" @cellClick="cellClick" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'methodIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'methodname', fieldtype: 'C', title: '生成方法',calculExpr:'',editRender: { name: 'input'}},
          { field: 'methodtype', fieldtype: 'C', title: '规则',syscode: 'methodtype',calculExpr:'',editRender: { name: 'select', options: []}},
          { field: 'methodlen', fieldtype: 'N', title: '编号长度',calculExpr:'',editRender: { name: 'input'}},
          { field: 'methodtag', fieldtype: 'C', title: '标识符',calculExpr:'',editRender: { name: 'input'}},
          { field: 'methodnumlen', fieldtype: 'N', title: '流水号长度',calculExpr:''}
        ],
        method: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('SAV', () => this.addOrEdit())
      this.$on('DEL', () => this.delMethod())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getPageList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.method = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async delMethod () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/method/delMethod',
            method: "post",
            data: this.method
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      async cellClick (row) {
        this.method = row.row
      },
      async pagechange (methodPage) {
        this.query.currPage = methodPage.currentPage
        this.query.pageSize = methodPage.pageSize
        this.getPageList()
      },
      async addOrEdit () {
        let model = this.$refs.xGrid.$refs.xGrid.getRecordset()
        let data = await request({
          url: '/kfgl/method/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          await this.getPageList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error('保存失败!')
        }
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/method/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
